import { render, staticRenderFns } from "./document-mobile.vue?vue&type=template&id=4c61a05a&scoped=true"
import script from "./document-mobile.vue?vue&type=script&lang=js"
export * from "./document-mobile.vue?vue&type=script&lang=js"
import style0 from "./document-mobile.vue?vue&type=style&index=0&id=4c61a05a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c61a05a",
  null
  
)

export default component.exports